import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { waLink, DEFAULT_WA_MESSAGE } from "../config/site";
import { WhatsAppIcon } from "./Cta";

// Routes avec une barre d'action fixe en bas : on masque le flottant pour ne pas gêner.
const HIDDEN_ON = ["/personnalisation"];

export default function FloatingWhatsApp() {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 320);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (HIDDEN_ON.includes(pathname)) return null;

  return (
    <motion.a
      href={waLink(DEFAULT_WA_MESSAGE)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Nous contacter sur WhatsApp"
      data-testid="floating-whatsapp"
      className="fixed bottom-5 right-5 z-40 flex items-center gap-2.5 rounded-full bg-electric py-3.5 pl-4 pr-5 font-display text-sm font-semibold text-white shadow-[0_16px_40px_-10px_rgba(22,119,255,0.7)]"
      initial={{ opacity: 0, y: 24, scale: 0.9 }}
      animate={visible ? { opacity: 1, y: 0, scale: 1 } : { opacity: 0, y: 24, scale: 0.9 }}
      transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
      style={{ pointerEvents: visible ? "auto" : "none" }}
    >
      <span className="relative flex">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white/40 opacity-60" />
        <WhatsAppIcon className="relative h-5 w-5" />
      </span>
      <span className="sm:hidden">WhatsApp</span>
      <span className="hidden sm:inline">Commander sur WhatsApp</span>
    </motion.a>
  );
}
